import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useMemo } from 'react';
import { getTitlePresentOptionsMap } from './title-present-selector';

const TitlePresentBadge = ({
  titlePresent,
  hideCopy,
  useAbbreviation,
  className,
  hideIcon,
}: {
  titlePresent: boolean;
  hideCopy?: boolean;
  useAbbreviation?: boolean;
  className?: string;
  hideIcon?: boolean;
}) => {
  const TITLE_PRESENT_OPTIONS_MAP = useMemo(
    () => getTitlePresentOptionsMap({}),
    [],
  );

  const matchingOption = useMemo(() => {
    return TITLE_PRESENT_OPTIONS_MAP.find(
      (option) => option.booleanValue === titlePresent,
    );
  }, [TITLE_PRESENT_OPTIONS_MAP, titlePresent]);

  return (
    <Button variant="ghost" className={cn('p-1 h-fit', className)}>
      {!hideIcon &&
        titlePresent === true &&
        TITLE_PRESENT_OPTIONS_MAP.find((option) => option.booleanValue)?.icon}

      {!hideIcon &&
        titlePresent === false &&
        TITLE_PRESENT_OPTIONS_MAP.find((option) => !option.booleanValue)?.icon}
      {!hideCopy && (
        <p className="rounded text-xs  text-gray-600">
          {useAbbreviation
            ? matchingOption?.abbreviation
            : matchingOption?.label}
        </p>
      )}
    </Button>
  );
};

export default TitlePresentBadge;
